import { aesEncrypt } from "./aes";
import { GET_TOKEN, LOGIN_API } from "./apis";
import md5 from "js-md5";

export function ajustaSenha(nSenha, userPassword) {
  let pwd = userPassword.toUpperCase().substr(0, 15);
  let keyS = generateKey(pwd);
  keyS = aesEncrypt(pwd, keyS, false).toUpperCase();
  let senhaCrip = aesEncrypt(nSenha, keyS, false).toUpperCase();

  return senhaCrip;
}

export function arraybufferToObject(buf) {
  return JSON.parse(new TextDecoder("utf-8").decode(buf));
}

export function generateKey(s) {
  let r = "";
  let i = 1;
  s = s.toUpperCase();
  if (s === "") s = "X";
  while (r.length < 32) {
    r = r + s.substr(i - 1, 1);
    if (i < s.length) {
      i++;
    } else {
      i = 1;
    }
  }
  return r;
}

export function generateCnonce() {
  let characters = "abcdef0123456789";
  let token = "";
  for (let i = 0; i < 16; i++) {
    let randNum = Math.round(Math.random() * characters.length);
    token += characters.substr(randNum, 1);
  }
  return token.toUpperCase();
}

export function getAuthToken(user, data, url) {
  // vazio caso seja uma destas chamadas específicas ou o usuário seja do tipo AD
  if (url === GET_TOKEN || (url === LOGIN_API && user.ad)) {
    return "";
  }
  data = data
    .replace(/[^\w]/gi, "")
    .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "");
  let ha2 = md5(user.token + ":" + data);
  ha2 = ha2.toUpperCase();
  user.nC = 1; //foi desativado o tratamento de nC
  let auth = md5(user.ha1 + ":" + user.cNonce + ":" + ha2 + ":" + user.nC);
  auth = auth.toUpperCase();
  return auth + ":" + user.cNonce + ":" + user.nC;
}

export function hex2String(hex) {
  let str = "";
  for (let i = 0; i < hex.length; i += 2) {
    let v = parseInt(hex.substr(i, 2), 16);
    str += String.fromCharCode(v);
  }
  return str;
}

export function stringToArray(a, s) {
  let i, l;
  for (i = 0, l = s.length; i < l; i++) {
    a.push(s.charCodeAt(i));
  }
  return a;
}
